/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddAdvertiserTodoTaskRequest,
  AddTodoTaskRequest,
  AdvertiserTodoTaskFilterRequest,
  AdvertiserTodoTaskResponse,
  AttachmentFilesRequest,
  AttachmentResponse,
  AttachmentVersion,
  CheckRequest,
  CheckResponse,
  CommentAddAttachmentRequest,
  CommentMessageRequest,
  CommentRequestDataWithFiles,
  CommentResponse,
  PageResponseTaskResponse,
  TaskGetRequest,
  TaskResponse,
  TodoTaskResponse,
  UpdateAdvertiserTodoTaskRequest,
  UpdateTaskRequest,
  UpdateTodoTaskRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Tasks<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags task-controller
   * @name UpdateTask
   * @summary Update Task
   * @request POST:/tasks/{taskId}
   * @secure
   * @response `200` `TaskResponse` OK
   */
  updateTask = (
    taskId: string,
    data: UpdateTaskRequest,
    params: RequestParams = {},
  ) =>
    this.request<TaskResponse, any>({
      path: `/tasks/${taskId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name AddCheck
   * @request POST:/tasks/{taskId}/checks
   * @secure
   * @response `200` `(CheckResponse)[]` OK
   */
  addCheck = (taskId: string, data: CheckRequest, params: RequestParams = {}) =>
    this.request<CheckResponse[], any>({
      path: `/tasks/${taskId}/checks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name UpdateCheck
   * @request POST:/tasks/{taskId}/checks/{checkId}
   * @secure
   * @response `200` `(CheckResponse)[]` OK
   */
  updateCheck = (
    taskId: string,
    checkId: string,
    data: CheckRequest,
    params: RequestParams = {},
  ) =>
    this.request<CheckResponse[], any>({
      path: `/tasks/${taskId}/checks/${checkId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name DeleteCheck
   * @request DELETE:/tasks/{taskId}/checks/{checkId}
   * @secure
   * @response `200` `(CheckResponse)[]` OK
   */
  deleteCheck = (taskId: string, checkId: string, params: RequestParams = {}) =>
    this.request<CheckResponse[], any>({
      path: `/tasks/${taskId}/checks/${checkId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name GetTaskArtworkPreviewComments
   * @summary Get Artwork Preview Comments
   * @request GET:/tasks/{taskId}/artworkPreview/{attachmentId}/comments
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getTaskArtworkPreviewComments = (
    taskId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/tasks/${taskId}/artworkPreview/${attachmentId}/comments`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name AddTaskArtworkPreviewComment
   * @summary Add Comment to Artwork Preview
   * @request POST:/tasks/{taskId}/artworkPreview/{attachmentId}/comments
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addTaskArtworkPreviewComment = (
    taskId: string,
    attachmentId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/tasks/${taskId}/artworkPreview/${attachmentId}/comments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name AddTodoTask
   * @request POST:/tasks/todos/{locationId}
   * @secure
   * @response `200` `TodoTaskResponse` OK
   */
  addTodoTask = (
    locationId: string,
    data: AddTodoTaskRequest,
    params: RequestParams = {},
  ) =>
    this.request<TodoTaskResponse, any>({
      path: `/tasks/todos/${locationId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name GetComments
   * @request GET:/tasks/todos/comments/{resourceId}
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getComments = (resourceId: string, params: RequestParams = {}) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/tasks/todos/comments/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name AddComment
   * @request POST:/tasks/todos/comments/{resourceId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addComment = (
    resourceId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/tasks/todos/comments/${resourceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name AddCommentForChild
   * @request POST:/tasks/todos/comments/{resourceId}/{subResourceId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addCommentForChild = (
    resourceId: string,
    subResourceId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/tasks/todos/comments/${resourceId}/${subResourceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name DeleteAttachments
   * @request POST:/tasks/todos/comments/deleteAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  deleteAttachments = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/tasks/todos/comments/deleteAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name AddAttachments
   * @request POST:/tasks/todos/comments/addAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addAttachments = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/tasks/todos/comments/addAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name UpdateNewVersion
   * @request POST:/tasks/todos/attachmentsVersions/{resourceId}/{category}/{attachmentId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  updateNewVersion = (
    resourceId: string,
    category: string,
    attachmentId: string,
    query: {
      filesRequest: AttachmentFilesRequest;
    },
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/tasks/todos/attachmentsVersions/${resourceId}/${category}/${attachmentId}`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name GetTasks
   * @request POST:/tasks/getTasks
   * @secure
   * @response `200` `PageResponseTaskResponse` OK
   */
  getTasks = (data: TaskGetRequest, params: RequestParams = {}) =>
    this.request<PageResponseTaskResponse, any>({
      path: `/tasks/getTasks`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name UpdateTaskAttachmentVersion
   * @summary Add Task Attachment Version
   * @request POST:/tasks/attachmentsVersions/{resourceId}/{category}/{attachmentId}
   * @deprecated
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  updateTaskAttachmentVersion = (
    resourceId: string,
    category: string,
    attachmentId: string,
    query: {
      filesRequest: AttachmentFilesRequest;
    },
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/tasks/attachmentsVersions/${resourceId}/${category}/${attachmentId}`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertiser-todo-task-controller
   * @name GetAdvertiserTodoTasks
   * @request GET:/tasks/advertiser-todos
   * @secure
   * @response `200` `(AdvertiserTodoTaskResponse)[]` OK
   */
  getAdvertiserTodoTasks = (
    query: {
      filter: AdvertiserTodoTaskFilterRequest;
    },
    params: RequestParams = {},
  ) =>
    this.request<AdvertiserTodoTaskResponse[], any>({
      path: `/tasks/advertiser-todos`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertiser-todo-task-controller
   * @name AddAdvertiserTodoTask
   * @request POST:/tasks/advertiser-todos
   * @secure
   * @response `200` `AdvertiserTodoTaskResponse` OK
   */
  addAdvertiserTodoTask = (
    data: AddAdvertiserTodoTaskRequest,
    params: RequestParams = {},
  ) =>
    this.request<AdvertiserTodoTaskResponse, any>({
      path: `/tasks/advertiser-todos`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name DeleteTodoTask
   * @request DELETE:/tasks/todos/{locationId}/{taskId}
   * @secure
   * @response `200` `TodoTaskResponse` OK
   */
  deleteTodoTask = (
    locationId: string,
    taskId: string,
    params: RequestParams = {},
  ) =>
    this.request<TodoTaskResponse, any>({
      path: `/tasks/todos/${locationId}/${taskId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name UpdateTodoTask
   * @request PATCH:/tasks/todos/{locationId}/{taskId}
   * @secure
   * @response `200` `TodoTaskResponse` OK
   */
  updateTodoTask = (
    locationId: string,
    taskId: string,
    data: UpdateTodoTaskRequest,
    params: RequestParams = {},
  ) =>
    this.request<TodoTaskResponse, any>({
      path: `/tasks/todos/${locationId}/${taskId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name DeleteComment
   * @request DELETE:/tasks/todos/comments/{commentId}
   * @secure
   * @response `200` `void` OK
   */
  deleteComment = (commentId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/tasks/todos/comments/${commentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name UpdateCommentMessage
   * @request PATCH:/tasks/todos/comments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  updateCommentMessage = (
    commentId: string,
    data: CommentMessageRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/tasks/todos/comments/${commentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name SetActiveVersion
   * @request PATCH:/tasks/todos/attachmentsVersions/{resourceId}/{attachmentId}/{version}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  setActiveVersion = (
    resourceId: string,
    attachmentId: string,
    version: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/tasks/todos/attachmentsVersions/${resourceId}/${attachmentId}/${version}`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name SetTaskAttachmentActiveVersion
   * @summary Set Task Attachment Active Version
   * @request PATCH:/tasks/attachmentsVersions/{resourceId}/{attachmentId}/{version}
   * @deprecated
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  setTaskAttachmentActiveVersion = (
    resourceId: string,
    attachmentId: string,
    version: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/tasks/attachmentsVersions/${resourceId}/${attachmentId}/${version}`,
      method: "PATCH",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertiser-todo-task-controller
   * @name DeleteAdvertiserTodoTask
   * @request DELETE:/tasks/advertiser-todos/{taskId}
   * @secure
   * @response `200` `AdvertiserTodoTaskResponse` OK
   */
  deleteAdvertiserTodoTask = (taskId: string, params: RequestParams = {}) =>
    this.request<AdvertiserTodoTaskResponse, any>({
      path: `/tasks/advertiser-todos/${taskId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags advertiser-todo-task-controller
   * @name UpdateAdvertiserTodoTask
   * @request PATCH:/tasks/advertiser-todos/{taskId}
   * @secure
   * @response `200` `AdvertiserTodoTaskResponse` OK
   */
  updateAdvertiserTodoTask = (
    taskId: string,
    data: UpdateAdvertiserTodoTaskRequest,
    params: RequestParams = {},
  ) =>
    this.request<AdvertiserTodoTaskResponse, any>({
      path: `/tasks/advertiser-todos/${taskId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name GetCommentsForChild
   * @request GET:/tasks/todos/comments/{resourceId}/{subresourceId}
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getCommentsForChild = (
    resourceId: string,
    subresourceId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/tasks/todos/comments/${resourceId}/${subresourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name DownloadCommentInlineDocument
   * @request GET:/tasks/todos/comments/{resourceId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadCommentInlineDocument = (
    resourceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/tasks/todos/comments/${resourceId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name GetAttachmentsWithVersions
   * @request GET:/tasks/todos/attachmentsVersions/{resourceId}
   * @secure
   * @response `200` `(AttachmentResponse)[]` OK
   */
  getAttachmentsWithVersions = (
    resourceId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse[], any>({
      path: `/tasks/todos/attachmentsVersions/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name GetAttachmentWithVersions
   * @request GET:/tasks/todos/attachmentsVersions/{resourceId}/{attachmentId}
   * @secure
   * @response `200` `(AttachmentVersion)[]` OK
   */
  getAttachmentWithVersions = (
    resourceId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentVersion[], any>({
      path: `/tasks/todos/attachmentsVersions/${resourceId}/${attachmentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name DownloadAttachmentVersion
   * @request GET:/tasks/todos/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @secure
   * @response `200` `File` OK
   */
  downloadAttachmentVersion = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/tasks/todos/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags todo-task-controller
   * @name DeleteVersion
   * @request DELETE:/tasks/todos/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  deleteVersion = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/tasks/todos/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name GetAttachmentsWithVersions1
   * @request GET:/tasks/attachmentsVersions/{resourceId}
   * @secure
   * @response `200` `(AttachmentResponse)[]` OK
   */
  getAttachmentsWithVersions1 = (
    resourceId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse[], any>({
      path: `/tasks/attachmentsVersions/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name GetAttachmentWithVersions1
   * @request GET:/tasks/attachmentsVersions/{resourceId}/{attachmentId}
   * @secure
   * @response `200` `(AttachmentVersion)[]` OK
   */
  getAttachmentWithVersions1 = (
    resourceId: string,
    attachmentId: string,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentVersion[], any>({
      path: `/tasks/attachmentsVersions/${resourceId}/${attachmentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name DownloadAttachmentVersion1
   * @request GET:/tasks/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @secure
   * @response `200` `File` OK
   */
  downloadAttachmentVersion1 = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/tasks/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags task-controller
   * @name DeleteTaskAttachmentVersion
   * @summary Delete Task Attachment Version
   * @request DELETE:/tasks/attachmentsVersions/{resourceId}/{attachmentId}/{versionId}
   * @deprecated
   * @secure
   * @response `200` `AttachmentResponse` OK
   */
  deleteTaskAttachmentVersion = (
    resourceId: string,
    attachmentId: string,
    versionId: number,
    params: RequestParams = {},
  ) =>
    this.request<AttachmentResponse, any>({
      path: `/tasks/attachmentsVersions/${resourceId}/${attachmentId}/${versionId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
